var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Payments"},[_vm._l((_vm.icons),function(icon,index){return _c('img',{key:index,style:({
        'width': _vm.$screen.width > 1024 ? icon.width : icon.mobWidth,
        order: _vm.$screen.width < 1024 ? icon.order : ''
      }),attrs:{"src":require(("@/assets/images/" + (icon.icon))),"alt":"payment icon"}})}),_c('About',{staticClass:"Payments-About"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }